var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedbackIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99906 12.45C10.9197 12.45 12.4766 10.8931 12.4766 8.97245C12.4766 7.05184 10.9197 5.49487 8.99906 5.49487C7.07845 5.49487 5.52148 7.05184 5.52148 8.97245C5.52148 10.8931 7.07845 12.45 8.99906 12.45Z",
    stroke: "#444444",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58965 8.97251C8.58965 9.19854 8.77289 9.38178 8.99893 9.38178C9.22496 9.38178 9.4082 9.19854 9.4082 8.97251C9.4082 8.74647 9.22496 8.56323 8.99893 8.56323C8.77289 8.56323 8.58965 8.74647 8.58965 8.97251Z",
    fill: "#444444",
    stroke: "#444444",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20312 5.1083C3.20312 5.1083 6.10111 0.664725 11.1243 2.40351C16.1474 4.1423 15.9542 9.16547 15.9542 9.16547",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7951 12.8361C14.7951 12.8361 12.4767 17.0865 7.26031 15.7341C2.04395 14.3817 2.04395 8.97217 2.04395 8.97217",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9541 2.78979V8.97216",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.04395 8.97217V15.1545",
    stroke: "#444444",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackIconDark);
export default __webpack_public_path__ + "static/media/feedback-icon-dark.c351425f448275987468edb8204f6749.svg";
export { ForwardRef as ReactComponent };